// extracted by mini-css-extract-plugin
export var addressFields = "_i1-0";
export var animationContainer = "_i1-1";
export var footer = "_i1-2";
export var lineItems = "_i1-3";
export var modalContent = "_i1-4";
export var orderName = "_i1-5";
export var strong = "_i1-6";
export var warning = "_i1-7";